<template>
  <div>
    <div class="content_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/main?lang='+ lang }">{{
          cooperation.title
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item, index) in brandList" :key="index">
        {{item.categoryName}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="border: 1px solid #e5e5e5; margin-top: 30px; margin-left: 20px; margin-right: 5px;">
    <div class="div1"><span style="line-height:30px;margin-top:20px;">{{ $t("section.trainingTag") }} : </span></div>
    <div class="div2 content_tag"  style="padding-bottom:22px;">
      <div class="tag-group div2-tag">
        <el-row>
        <button v-for="item in cateList" :key="item.cateName" style="margin-top: 5px; min-width: 100px; cursor: pointer; border-radius: 10px; margin-left: 20px; height: 38px; border: none; text-align: center;" :class="{active : active == item.cateName}" @click="selected(item.cateName, item.id, item.isAll)">&nbsp;&nbsp;{{item.cateName}}&nbsp;&nbsp;</button>
        </el-row>
      </div>
      <br />
    </div>
  </div>
    <div class="content-container">
      <div class="search-form" style="display: none;">
        <el-form
          ref="examForm"
          :inline="true"
          :model="query"
          label-width="100px"
          class="examForm"
          @submit.native.prevent>
          <span style="line-height: 40px; width: 120px; vertical-align: middle;text-align: center;">Course Name</span>
          <el-form-item label="" prop="courseName">
            <el-input
              v-model="query.courseName"
              autocomplete="off"
              style="width: 500px;"
              @keyup.enter.native="submitForm('examForm')"
              :placeholder="$t('exam.course.courseName')"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="custom-search-btn" @click="submitForm('examForm')">{{
              $t("search")
            }}</el-button>
            <el-button @click="resetForm('examForm')">{{
              $t("reset")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="course-card-list" style="overflow-y:none;">
        <transition
          name="fade-transform"
          mode="out-in"
          v-for="course in courseList"
          :key="course.id">

          <!-- :style="popularCourseClass" -->
          <div class="single-popular-course"   v-show="course.show" @click="handleStartCourse(course, lang, categoryId)">
           <div>
            <img :src="course.imageUrl" :alt="course.courseName" />
            <div class="course-content" style="min-height: 85px;">
              <h4 style="line-height: 25px; margin-bottom: 5px;">{{ course.courseName }}</h4>
              <div class="meta d-flex align-items-center" v-if="course.college">
                <a href="#">{{ course.college }} & {{ course.major }}</a>
                <span><i class="fa fa-circle" aria-hidden="true"></i></span>
                <a href="#" style="font-size: 10px; margin-right: 0; width: 45px;">{{ course.teacher }}</a>
              </div>
              <p>{{ course.simpleDesc | simpleStrFilter(20) }}</p>
            </div>
           </div>
            <div class="seat-rating-fee d-flex justify-content-between">
              <div class="seat-rating h-100 d-flex align-items-center">
                <div
                  class="seat"
                  :title="$t('exam.course.courses.registerStudentsCnt')"
                >
                  <i class="el-icon-user-solid" aria-hidden="true"></i>
                  {{ course.chargePrice }}
                </div>
                <div class="rating" :title="$t('exam.course.courses.level')">
                  <i class="el-icon-star-on" aria-hidden="true"></i>
                  {{ course.level }}
                </div>
              </div>
              <div :class="course.chargeType === 0? 'course-fee h-100': 'course-charge h-100'" style="background-color: #00b5b1;">
                <a href="#">{{course.chargeType === 0? $t("exam.course.atOnce"): "$" + course.chargePrice}}</a>
              </div>
            </div>
          </div>
        </transition>
        <i
          v-if="courseList !== undefined && courseList.length > 0"
          v-for="count in courseList.length"
          :key="count"
        ></i>
      </div>
      <el-row style="text-align: center; margin-bottom: 50px">
        <el-col :span="24">
          <el-button
            v-if="!isLastPage"
            type="default"
            @click="scrollList"
            :loading="loading"
            style="margin-bottom: 100px"
            >{{ $t("load.loadMore") }}</el-button
          >
        </el-col>
      </el-row>

      <div>
        <el-row class="list-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="query.pageNum"
            :page-sizes="[16]"
            :page-size="16"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { courseList } from "@/api/exam/course";
import { messageWarn, notifyFail } from "@/utils/util";
import { simpleStrFilter } from "@/filters/index";
import { listBase } from "@/api/sigen/courseCategory";
import { switchLanguage } from "@/api/sigen/paginationLang";
import { getToken } from '@/utils/auth';

export default {
  inject: ["getCateId"],
  data() {
    return {
      language: this.$i18n.locale,
      info: 'info',
      total: 0,
      loading: true,
      isLastPage: false,
      isLogin: 0,
      lang: 'en',
      categoryId: '-1',
      popularCourseClass: 'width: calc((92% - 72px) / 4);',
      login: {
        form: {
          tenantCode: 'gitee',
          identifier: '',
          credential: '123456',
          code: '8888',
          randomStr: '',
          rememberMe: false
        },
        rules: {
          identifier: [{
            required: true, trigger: 'blur', message: this.$t('validate.inputUsername')
          }],
          credential: [
            { required: true, trigger: 'blur', message: this.$t('validate.inputPassword') },
            { min: 4, trigger: 'blur', message: this.$t('passwordMustFourLength') }],
          code: [
            { required: true, message: this.$t('validate.inputValidationCode'), trigger: 'blur' },
            { min: 4, max: 4, message: this.$t('validationCodeMustFourLength'), trigger: 'blur' }
          ]
        },
        loading: false,
        passwordType: 'password',
        show: 1,
        isLogin: 0,
        lang: "en",
        code: {
          src: '/sg-user-service/v1/code',
          value: '',
          len: 4,
          type: 'image'
        }
      },
      query: {
        sort: 'id',
        order: 'asc',
        page: 1,
        pageSize: 16,
        langCode: '',
        cateCode: '',
        isLogin: 0,
        courseName: '',
        status: 0,
        isAll: null
      },
      courseList: [],
      cateList: [],
      brandList: [],
      cooperation: '',
      wpList: [
        {
          name: '全选'
        },
        {
          name: '食品饮料'
        },
        {
          name: '鲜花'
        },
        {
          name: '蛋糕'
        },
        {
          name: '水果生鲜'
        },
        {
          name: '服装鞋帽'
        },
        {
          name: '其它'
        }
      ],
      active: '全部'
    };
  },
  created() {
    let lang = this.getRouteParams();
    this.handleSetLanguage(lang);
    this.handleLogin();
    this.lang = lang;
    this.switchLanguage(this.lang);
    let cateKey = this.getCateId();
    this.categoryId = cateKey;
    this.listStepPull(this.isLogin, lang, cateKey);
    this.query.langCode = lang;
    this.getCourseList();
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    })
  },
  methods: {
    switchLanguage(lang) {
      switchLanguage(lang)
    },
    handleLogin() {
      this.login.form.tenantCode = 'gitee';
      if (getToken() === undefined) {
        this.identifier = "sigenergy";

        this.login.loading = true
        this.login.form.identifier = this.identifier
        // 登录，获取 token
        this.$store.dispatch('LoginByUsername', this.login.form).then(() => {
          this.login.loading = false
        }).catch(() => {
          this.login.loading = false
        })
      }
    },
    // 计算浏览器像素宽度
    selected(name, id, all) {
      this.active = name;
      this.chooseCateCode(id, all);
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      if (this.listLoading) {
        messageWarn(this, this.$t("load.loading"));
        return;
      }
      this.getCourseList();
    },
    handleCurrentChange(val) {
      console.log("handleCurrentChange page:" + val);
      this.query.pageNum = val;
      this.query.page = val;
      if (this.listLoading) {
        messageWarn(this, this.$t("load.loading"));
        return;
      }
      this.getCourseList(true);
    },
    chooseCateCode(cateCode, all) {
      if (all === 0) {
        this.query.cateCode = cateCode;
      }
      this.query.isAll = all;
      this.courseList = [];
      this.getCourseList();
    },
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.language = lang;
    },
    checkLogin() {
      if (this.userInfo.id !== undefined) {
        this.login.login = true;
      }
    },
    getRouteParams() {
      // 使用 let phone=this.$route.query.name 来获Get请求参数的值
      let lang = this.$route.query.lang;
      // let name = this.$route.query.name;
      // let code = this.$route.query.code;
      return lang;
    },
    listStepPull(isLogin, lang, cateId) {
      if (lang === undefined) {
        return
      }
      listBase(isLogin, lang, cateId)
        .then((res) => {
          this.cateList = res.data.result.cateList;
          this.cooperation = res.data.result.cooperation;
          this.brandList = res.data.result.brandList;
          if (this.cateList !== null && this.cateList !== undefined) {
            this.active = this.cateList[0].cateName;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    simpleStrFilter: simpleStrFilter,
    submitForm() {
      this.query.page = 1;
      this.getCourseList(true);
    },
    resetForm() {
      this.query.courseName = "";
      this.getCourseList(true);
    },
    getCourseList(reset = false) {
      this.loading = true;
      // 样式调整
      this.popularCourseClass = 'width: calc((92% - 72px) / 4);';
      console.log("courseList page:" + this.query.page);
      courseList(this.query).then((response) => {
        if (reset) {
          this.courseList = [];
        }
        const { total, isLastPage, list } = response.data.result;
        this.updateCourseList(list);
        this.total = total;
        this.isLastPage = isLastPage;
        this.loading = false;
        this.query.cateCode = '';
        this.query.courseName = '';
        this.query.isAll = null;
      }).catch(() => {
        notifyFail(this, this.$t("load.loadFailed"));
        this.loading = false;
      });
    },
    handleStartCourse(course, lang, categoryId) {
      // this.$router.push({
      //   name: "video-details",
      //   query: { courseId: course.id, lang: lang, categoryId: categoryId }
      // });
      var url = 'video-details?courseId=' + course.id + '&lang=' + lang + '&categoryId=' + categoryId;
      window.open(url, "_blank");
    },
    scrollList() {
      if (this.isLastPage) {
        messageWarn(this, this.$t("load.noMoreData"));
        return;
      }
      if (this.loading) {
        messageWarn(this, this.$t("load.loading"));
        return;
      }
      this.loading = true;
      setTimeout(() => {
        this.query.page++;
        courseList(this.query)
          .then((response) => {
            const { total, isLastPage, list } = response.data.result;
            this.updateCourseList(list);
            this.total = total;
            this.isLastPage = isLastPage;
            this.loading = false;
          })
          .catch(() => {
            messageWarn(this, this.$t("load.loadFailed"));
            this.loading = false;
          });
      }, 500);
    },
    updateCourseList(list) {
      if (list === undefined || list.length === 0) {
        return list;
      }
      list.forEach((item) => {
        item.show = false;
      });

      if (this.courseList.length === 0) {
        this.courseList = list;
      } else {
        list.forEach((item) => {
          let exist = false;
          for (let i = 0; i < this.courseList.length; i++) {
            if (this.courseList[i].id === item.id) {
              exist = true;
            }
          }
          if (!exist) {
            this.courseList.push(item);
          }
        });
      }

      for (let i = 0; i < list.length; i++) {
        setTimeout(() => {
          list[i].show = true;
        }, 150 + 100 * i);
      }
    }
  }
};
</script>
  <style lang="scss" rel="stylesheet/scss" scoped>
.clever-category {
  display: flex;
  width: 100%;
  height: 80px;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  justify-content: center;
  -webkit-box-pack: center;
  z-index: 2;
  h3 {
    text-align: center;
    font-size: 30px;
    text-transform: uppercase;
    letter-spacing: 0.75px;
    color: #3762f0;
    margin-bottom: 0;
  }
}
.clever-category::after {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  content: "";
  background-color: rgba(215, 224, 252, 0.9);
  z-index: -1;
}
.bg-img {
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}
.course-card-list {
  width: 100%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  overflow-y:none;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .single-popular-course {
    width: calc((92% - 72px) / 4);
    box-sizing: border-box;
    position: relative;
    margin: 0 24px 24px 0;
    border-radius: 6px;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
    border: 1px solid #ebebeb;
    &:nth-of-type(4n + 0) {
      margin-right: 0;
    }
    .card-item-snapshoot {
      background-origin: border-box;
      background-size: cover;
      background-color: #f0f0f0;
      background-position: 49% 38%;
      height: 172px;
      display: block;
      border-radius: 6px 6px 0 0;
    }
    .card-item-detail {
      padding: 20px;
      .card-item-name {
        display: -webkit-box;
        overflow: hidden;
      }
      .card-item-course {
        --x-height-multiplier: 0.342;
        --baseline-multiplier: 0.22;
        font-weight: 300;
        font-style: normal;
        letter-spacing: 0;
        .card-item-course-detail {
          color: rgba(0, 0, 0, 0.54);
          fill: rgba(0, 0, 0, 0.54);
        }
      }
    }
  }
  > i {
    width: 30%;
    padding-right: 12px;
  }
}

.content_header {
  margin-left: 10px;
  margin-top: 20px;
}

.content_tag {
  margin-left: 20px;
  .tag {
    margin-left: 20px;
  }
  font-size: 16px;
  word-wrap: break-word; /* 或者使用 overflow-wrap: break-word; */
  white-space: normal;
}

.tag-group {
  margin-top: 10px;
  height: 60px;
}

.content-container {
  margin-left: 20px;
  width: 105%;
  position: relative; /* 或 absolute, fixed, depending on layout needs */
  bottom: 0; /* 将div固定在父容器的底部 */
}

.list-pagination {
  margin-left: 30px;
  display: flex;
  justify-content: flex-end;
  margin: 1px 0 0px 0;
  background: #ffffff;
  width: 92%;
}

/* 新的CSS类，用于覆盖默认的搜索按钮样式 */
.custom-search-btn {
  background-color: #00B5B1; /* 修改为你想要的颜色 */
  border: 1px solid #00B5B1;
}

.active {
  font-size: 14px;
  background: #00B5B1;
  border: 1px solid #00B5B1;
  color: #fff;
  border-radius: 10px; /* 圆角半径 */
  padding: 5px; /* 内边距 */
  margin: 5px; /* 外边距 */
 }

 .div1, .div2 {
    margin: 3px;
  }
  .div1{
    margin-bottom: 1px; margin-left:10px;
  }
  .div2{
    border: 0px solid #e5e5e5;
  }
  .div2-tag{
    height: 30px; margin-bottom: 20px; padding: 10px;
  }
  .div2-row-tag{
    font-size: 14px; line-height: 1.5; color: #808080;  width: 100%;cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/sigen/course/index.vue